import { createSelector } from 'reselect';
import {
    get,
    isEqual
} from 'lodash';
import {
    TRANSACTION_FAILURE,
    TRANSACTION_LOAD,
    TRANSACTION_SUCCESS,
    CHECK_FOR_LINKED_REFUND_SUCCESS,
    CHECK_FOR_LINKED_REFUND_LOADING,
    CHECK_FOR_LINKED_REFUND_FAILURE
} from './transactionActions';
import { getEntityByName } from '../appEntities';

const initialState = {
    loading: false
};

export default function reducer(state = initialState, action = {}) {
    let newState;
    switch (action.type) {

        case TRANSACTION_LOAD:
            newState = {
                ...state,
                loading: true
            };

            return isEqual(state, newState) ? state : newState;

        case TRANSACTION_SUCCESS:
            newState = {
                ...state,
                loading: false,
                transaction: action.transaction
            };

            return isEqual(state, newState) ? state : newState;

        case TRANSACTION_FAILURE:
            newState = {
                ...state,
                error: action.error,
                loading: false
            };

            return isEqual(state, newState) ? state : newState;

        case CHECK_FOR_LINKED_REFUND_SUCCESS:
            newState = {
                ...state,
                linkedRefunds: action.results.rows,
                isLinkedRefundsLoading: false
            };

            return isEqual(state, newState) ? state : newState;

        case CHECK_FOR_LINKED_REFUND_LOADING:
            newState = {
                ...state,
                linkedRefunds: null,
                isLinkedRefundsLoading: true
            };

            return isEqual(state, newState) ? state : newState;

        case CHECK_FOR_LINKED_REFUND_FAILURE:
            newState = {
                ...state,
                linkedRefunds: null,
                isLinkedRefundsLoading: false,
                isLinkedRefundError: action.error
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getTransactionEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'transaction')
);

export const getIsTransactionLoading = createSelector(
    getTransactionEntity,
    (entity) => get(entity, 'loading')
);

export const getTransactionError = createSelector(
    getTransactionEntity,
    (entity) => get(entity, 'error')
);

export const getTransactionErrorMessage = createSelector(
    getTransactionError,
    (error) => get(error, 'message')
);

export const getTransaction = createSelector(
    getTransactionEntity,
    (entity) => get(entity, 'transaction')
);

export const getIsLinkedRefundLoading = createSelector(
    getTransactionEntity,
    (entity) => get(entity, 'isLinkedRefundsLoading')
);

export const getLinkedRefunds = createSelector(
    getTransactionEntity,
    (entity) => get(entity, 'linkedRefunds')
);

export const getLinkedRefundsError = createSelector(
    getTransactionEntity,
    (error) => get(error, 'message')
);